import React from "react";
import Home from "../components/Home/Home";


export default function Homepage() {
  return (
    <>
      <Home/>
    </>
  );
}
